import axios from "axios";

import { authDeviceWithDomainHeader } from "../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
class RegistrationService {
  async getRegistrationsList(filter = "") {
    return await axios
      .get(API_URL + "pbx-service/active-els/registrations" + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  async getActiveExtension(filter = "") {
    return await axios
      .get(API_URL + "pbx-service/active-els/active_extentsion" + filter, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  async getActiveCallList() {
    return await axios
      .get(API_URL + "pbx-service/active-els/calls", {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new RegistrationService();
